import {css} from "lit";

export const annotationHeaderStyles = css`
	.annotation-header {
		margin-bottom: 5px;
	}

	.annotation-header .annotation-topic {
		margin-right: 5px;
		font-weight: bolder;
		font-size: 13px;
	}

	.annotation-header .annotation-timestamp {
		font-size: 12px;
		color: var(--pn-outline-annotation-timestamp-color);
	}
`;
